import IdentityClient from "./IdentityClient";
import { Constants } from "../../constants/constants";
import Helpers from "../../commons/helpers";
import { IMultiLanguageContent } from "../../commons/interfaces";

export interface IServiceGetAllRequest {
    tenantCode?: string;
    organizationId?: string;
    searchText?: string;
}

export interface IServiceGetAllResponse {
    tenantCode: any
    clientIds: string[]
    serviceClients: any
    tenantServices: TenantService[]
    serviceRelations: any
    organizations: any
    serviceCode: string
    serviceName: string
    description?: string
    userAgreement?: IMultiLanguageContent;
    termsOfService?: IMultiLanguageContent;
    userPolicy?: IMultiLanguageContent;
    searchText: any
    endPoint: any
    id: string
}
export interface TenantService {
  tenantCode: string
  serviceCode: string
  id: string
}

const IdentityServiceService = {
    async getAll(data: IServiceGetAllRequest): Promise<IServiceGetAllResponse[]> {
        let queryString = Helpers.handleFormatParams(data);
        if (queryString) {
            queryString = "?" + queryString;
        }
        const result = await IdentityClient().get(
            `${Constants.ApiPath.SERVICE.GET_ALL}${queryString}`
        );
        return result.data.result;
    },
}

export default IdentityServiceService;